import { Result } from 'antd';
import { isNil } from 'lodash/fp';
import { useTranslation } from 'react-i18next';

type NotFoundResultProps = {
    subTitle?: string;
    title?: string;
};

const NotFoundResult = ({ subTitle, title }: NotFoundResultProps) => {
    const { t } = useTranslation(['common']);

    return (
        <Result
            status="404"
            subTitle={!isNil(subTitle) ? subTitle : t('common:errors:404:description')}
            title={!isNil(title) ? title : t('common:errors:404:title')}
        />
    );
};

export default NotFoundResult;
